import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-post-source-info',
  templateUrl: './post-source-info.component.html',
  styleUrls: ['./post-source-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PostSourceInfoComponent {
  @Input() postId: string;

  constructor() {}
}
